import type { User } from '../../types/comments';
import { EntityCommentThread } from './EntityCommentThread';

interface TaskCommentThreadProps {
  taskId: number;
  /** Optional — resolved from the workspace member list when omitted. */
  users?: User[];
  /** Optional — resolved from the authed user + member list when omitted. */
  currentUser?: User;
  isReadOnly?: boolean;
}

/** Thin adapter over {@link EntityCommentThread} for a task's discussion. */
export function TaskCommentThread({ taskId, ...rest }: TaskCommentThreadProps) {
  return <EntityCommentThread target={{ type: 'task', taskId }} {...rest} />;
}
